import Subnet from '@/common/models/subnet.model';

export type SubnetActionsArgs = {
  resource: string,
  Model: any
}

const subnetsActions = ({ resource, Model }: SubnetActionsArgs): CommonActionTree<any> => ({
  CREATE({ commit }, subnet): Promise<FetchResponse> {
    return this.$api.post(resource, subnet)
      .then((res) => {
        const newItem = new Model(res.data);
        commit('CHANGE', { item: newItem, merge: false, view: res.data.network_id });
        commit('CLEAR_ERRORS');
        return res;
      })
      .catch((error) => {
        commit('SET_ERRORS', error);

        throw error;
      });
  },
  UPDATE({ commit }, subnet): Promise<FetchResponse> {
    return this.$api.patch(`${resource}/${subnet.id}`, subnet)
      .then((res) => {
        const newItem = new Model(res.data);
        commit('CHANGE', { item: newItem, merge: false, view: res.data.network_id });
        commit('CLEAR_ERRORS');
        return res;
      })
      .catch((error) => {
        commit('SET_ERRORS', error);

        throw error;
      });
  }
});

export default new class implements CommonStore<any, Subnet> {
  name = 'subnets';
  resource = '/api/v2/compute/subnets';
  Model = Subnet;
  actions = (args: SubnetActionsArgs) => subnetsActions(args);
}();
